export default {
  getPagination: (state) => state.pagination,
  getFlowProcesses: (state) => state.flowProcesses,
  getProcessData: (state) => state.processData,
  getSelectedProcess: (state) => state.selectedProcess,
  getFlowsFilter: (state) => state.flowsFilter,
  getLinks: (state) => state.links,
};
